import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oneSimpleApi = defineConnector({
  identifier: "oneSimpleApi",
  name: "OneSimple API",
  tagLine: "Utility API",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://onesimpleapi\\.com/.*",
  auth: (app) => queryAuth([{ name: "token", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [OneSimple API](https://onesimpleapi.com/) and copy your API token from your account settings.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://onesimpleapi.com/api/user",
  },
});
